import type { Trade } from '../../types';

export function buildJournalTradesByDay(trades: Trade[]): Record<string, Trade[]> {
    const grouped: Record<string, Trade[]> = {};

    for (const trade of Array.isArray(trades) ? trades : []) {
        const dateKey = String(trade?.date ?? '').trim();
        if (!dateKey) continue;

        (grouped[dateKey] = grouped[dateKey] || []).push(trade);
    }

    return grouped;
}